import { Language, description} from "../zugferd_2_3_2/language"
export { Language, description }